import { createTheme } from '@mui/material/styles';

const PRIMARY = {
  lighter: '#80b779',
  light: '#70a06a',
  main: '#80B779',
  dark: '#50724c',
  darker: '#405b3c',
  contrastText: '#fff',
};

const SECONDARY = {
  lighter: '#d8d8ba',
  light: '#b9b99f',
  main: '#9a9a85',
  dark: '#7b7b6a',
  darker: '#5d5d50',
  contrastText: '#fff',
};

const scrollbarStyles = {
  html: {
    scrollbarWidth: 'thin',
    scrollbarColor: '#80B779 #e8efe7',
  },
  body: {
    scrollbarWidth: 'thin',
    scrollbarColor: '#80B779 #e8efe7',
  },
  '*': {
    scrollbarWidth: 'thin',
    scrollbarColor: '#80B779 #e8efe7',
  },
  '*::-webkit-scrollbar': {
    width: '10px',
    height: '10px',
  },
  '*::-webkit-scrollbar-track': {
    background: '#e8efe7',
  },
  '*::-webkit-scrollbar-thumb': {
    backgroundColor: '#80B779',
    borderRadius: '8px',
    border: '2px solid #e8efe7',
  },
  '*::-webkit-scrollbar-thumb:hover': {
    backgroundColor: '#50724c',
  },
};

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: PRIMARY,
    secondary: SECONDARY,
    background: {
      default: '#121212',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: scrollbarStyles,
    },
  },

// import { createTheme } from '@mui/material/styles';

// export const darkTheme = createTheme({
//   palette: {
//     mode: 'dark',
//     primary: {
//       main: '#103996',
//     },
//     background: {
//       default: '#121212',
//     },
//   },

});
